export const RESET_PASSWORD = 'containers/ResetPasswordPage/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'containers/ResetPasswordPage/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'containers/ResetPasswordPage/RESET_PASSWORD_ERROR';

export const LOAD_TOKEN = 'containers/ResetPasswordPage/LOAD_TOKEN';
